
import api from '@/api/logout';
import { defineComponent } from 'vue';

interface IState {
  redirect: string;
}

export default defineComponent({
  data() {
    return {
      redirect: this.$route.query.redirect,
    } as IState;
  },
  mounted() {
    api.logout(this.redirect);
  },
});
